import React from "react";
import { Check, X } from "lucide-react";

const RULES = [
  { key: "len", label: "At least 8 characters", test: (p) => p.length >= 8 },
  { key: "case", label: "Upper & lower case letters", test: (p) => /[a-z]/.test(p) && /[A-Z]/.test(p) },
  { key: "num", label: "At least one number", test: (p) => /\d/.test(p) },
  { key: "sym", label: "At least one symbol (!@#$…)", test: (p) => /[^A-Za-z0-9]/.test(p) },
];

const LEVELS = [
  { label: "Too weak", cls: "bg-rose-500", text: "text-rose-600 dark:text-rose-400" },
  { label: "Weak", cls: "bg-rose-500", text: "text-rose-600 dark:text-rose-400" },
  { label: "Fair", cls: "bg-amber-500", text: "text-amber-600 dark:text-amber-400" },
  { label: "Good", cls: "bg-lime-500", text: "text-lime-600 dark:text-lime-500" },
  { label: "Strong", cls: "bg-emerald-500", text: "text-emerald-600 dark:text-emerald-400" },
];

export function passwordScore(password) {
  return RULES.reduce((n, r) => n + (r.test(password) ? 1 : 0), 0);
}

export default function PasswordStrength({ password }) {
  if (!password) {
    return (
      <p data-testid="password-hint" className="text-xs text-muted-foreground mt-1.5">
        For your security, use a strong password — 8+ characters with upper & lower case, a number and a symbol.
      </p>
    );
  }
  const score = passwordScore(password);
  const level = LEVELS[score];
  return (
    <div data-testid="password-strength" className="mt-2 space-y-2">
      <div className="flex items-center gap-2">
        <div className="flex-1 flex gap-1">
          {[0, 1, 2, 3].map((i) => (
            <div
              key={i}
              className={`h-1.5 flex-1 rounded-full transition-colors ${i < score ? level.cls : "bg-slate-200 dark:bg-slate-700"}`}
            />
          ))}
        </div>
        <span data-testid="password-strength-label" className={`text-xs font-semibold ${level.text}`}>
          {level.label}
        </span>
      </div>
      <ul className="grid grid-cols-1 gap-1">
        {RULES.map((r) => {
          const ok = r.test(password);
          return (
            <li
              key={r.key}
              data-testid={`password-rule-${r.key}`}
              className={`flex items-center gap-1.5 text-xs ${ok ? "text-emerald-600 dark:text-emerald-400" : "text-muted-foreground"}`}
            >
              {ok ? <Check className="w-3.5 h-3.5 shrink-0" /> : <X className="w-3.5 h-3.5 shrink-0 opacity-50" />}
              {r.label}
            </li>
          );
        })}
      </ul>
    </div>
  );
}
